import { Fragment, ReactElement, useMemo } from 'react';
import {
  CivilStatusStampCertificate,
  CivilStatusNotesText,
  CivilStatusDocumentRegistry,
  CivilStatusDocumentSerie,
} from 'shell/authorizations/civil-status';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';
import { DisabledTableServiceCivilStatusMenu } from 'shell/view-models/disabled-menu';
import ServiceTableCollapse from './service-table-collapse';
import { useUserProfile } from 'shell/hooks/use-user-profile';

interface NestedItemsCivilStatusProps {
  link: string;
  onSubItemClick?: () => void;
}

const NestedItemsCivilStatus = ({
  link,
  onSubItemClick,
}: NestedItemsCivilStatusProps): ReactElement => {
  const actions = useActionAuthorization({
    stamp: CivilStatusStampCertificate,
    annotation: CivilStatusNotesText,
    registry: CivilStatusDocumentRegistry,
    serie: CivilStatusDocumentSerie,
  });

  const { userProfile } = useUserProfile();

  const gestioneTabelleSistema = userProfile.datiLogin?.profile?.feature?.sistema;

  const visibilityServiceTable = useMemo(() => {
    return (
      (!actions.stamp && !actions.annotation && !actions.registry && !actions.serie) ||
      gestioneTabelleSistema === '0'
    );
  }, [actions, gestioneTabelleSistema]);

  return (
    <Fragment>
      {visibilityServiceTable ? undefined : (
        <ServiceTableCollapse
          link={link}
          onSubItemClick={onSubItemClick}
          active={(actions || {}) as DisabledTableServiceCivilStatusMenu}
        />
      )}
    </Fragment>
  );
};

NestedItemsCivilStatus.displayName = 'nested Items civil status component';

export default NestedItemsCivilStatus;
